/**
 * Maps UI fetch params to SMSWiser /drops/all API query params.
 * Date-range fetches ignore `length` on the backend — always send page size cap.
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  capManualFetchLength,
  DROPS_FETCH_LENGTH_MAX,
} from '@trafficpulse/shared';

import type { SmswiserDropsQueryParams } from '@/hooks/smswiser/drops/useSmswiserDrops';

/** Client timeout for deep date-range pagination (backend allows up to 20 min). */
export const DROPS_DATE_RANGE_TIMEOUT_MS = 600_000;

export function buildDropsApiParams(params: SmswiserDropsQueryParams): SmswiserDropsQueryParams {
  const length = params.from
    ? DROPS_FETCH_LENGTH_MAX
    : capManualFetchLength(params.length);

  return {
    search: params.search,
    ...(params.landCode ? { landCode: params.landCode } : {}),
    start: params.start,
    length,
    ...(params.from ? { from: params.from, to: params.to } : {}),
  };
}

export function getDropsRequestTimeoutMs(params: SmswiserDropsQueryParams): number | undefined {
  return params.from ? DROPS_DATE_RANGE_TIMEOUT_MS : undefined;
}
